import axiosClient from ".";

class ReportAPI {
  static getReports(data) {
    return axiosClient.post(`/super_admin/api/reports.json`, data);
  }
}
export default ReportAPI;
